// 企业相关全部请求
import environment from '../../config/environment'
import {getCompanyListAPI, getSearchExampleAPI} from '../api'
import {encrypt} from '../common'
import qs from 'qs'

// 常量
const API_CODE = environment.apiCode
const API_KEY = environment.apiKey

// 企业列表查询
function getCompanyList (paramObj, token) {
    // json转string
    const paramStr = JSON.stringify(paramObj)
    // 变密
    const params = qs.stringify({
        code: API_CODE,
        token: token,
        param: encrypt(paramStr, API_CODE, API_KEY)
    })
    return getCompanyListAPI(params)
}
// 样例公司列表获取接口
function getSearchExample (paramObj, token) {
    // json转string
    const paramStr = JSON.stringify(paramObj)
    // 变密
    const params = qs.stringify({
        code: API_CODE,
        token: token,
        param: encrypt(paramStr, API_CODE, API_KEY)
    })
    return getSearchExampleAPI(params)
}

export {getCompanyList, getSearchExample}



// WEBPACK FOOTER //
// ./src/request/index/company.js